import { IAction, ActionType, ISetContextAction } from '../actions/index';
import * as _ from 'lodash';




var healthyChildrenDomain: string = 'healthychildren.org';
var pointofCareDomain: string = 'solutions.aap.org';
var pediatricCareOnlineDomain: string = 'pediatriccare.solutions.aap.org';
var redBookOnlineDomain: string = 'redbook.solutions.aap.org';
var pediatricPatientEducationDomain: string = 'patiented.solutions.aap.org';
var pediatricCodingNewsletterDomain: string = 'coding.solutions.aap.org';
// new Silverchair ulrs
var SCpediatricCareOnlineDomain: string = 'publications.aap.org/pediatriccare';
var SCredBookOnlineDomain: string = 'publications.aap.org/redbook';
var SCpediatricPatientEducationDomain: string = 'publications.aap.org/patiented';
var SCpediatricCodingNewsletterDomain: string = 'publications.aap.org/codingnews';


export function getSourceDomainSVG(friendlyUrl: string) {

    var logoName: string = '';

    if (_.includes(friendlyUrl, pointofCareDomain)) {
        logoName = 'icon-Solutions';
    }
    if (_.includes(friendlyUrl, pediatricCareOnlineDomain) || _.includes(friendlyUrl, SCpediatricCareOnlineDomain)) {
        logoName = 'icon-PCO-(1)';
    }
    if (_.includes(friendlyUrl, healthyChildrenDomain)) {
        logoName = 'icon-HC';
    }
    if (_.includes(friendlyUrl, redBookOnlineDomain) || _.includes(friendlyUrl, SCredBookOnlineDomain)) {
        logoName = 'icon-Red-Book';
    }
    if (_.includes(friendlyUrl, pediatricPatientEducationDomain) || _.includes(friendlyUrl, SCpediatricPatientEducationDomain)) {
        logoName = 'icon-Patient-Education';
    }
    if (_.includes(friendlyUrl, pediatricCodingNewsletterDomain) || _.includes(friendlyUrl, SCpediatricCodingNewsletterDomain)) {
        logoName = 'icon-Coding';
    }

    return logoName;
}